import { jsx as _jsx } from "react/jsx-runtime";
import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
const CLEAR_BUTTON_DEFAULT_RIGHT_POSITION = 0.5;
const ClearIconButton = ({ clearButtonAriaLabel, clearButtonRightPosition = CLEAR_BUTTON_DEFAULT_RIGHT_POSITION, disabled = false, onClick, }) => {
    return (_jsx(IconButton, { "aria-label": clearButtonAriaLabel, disabled: disabled, onClick: onClick, sx: {
            position: 'absolute',
            right: (theme) => theme.spacing(clearButtonRightPosition),
        }, children: _jsx(Close, {}) }));
};
export default ClearIconButton;
